import React, { PureComponent } from "react"
import { connect } from "react-redux"

export default function withAuth(ComponentToBeRendered) {
  class Authenticate extends PureComponent {
    componentWillMount() {
      if(this.props.isAuthenticated === false) {
        this.props.history.push("/signin")
      }
    }
    componentWillUpdate(nextProps) {
      if(nextProps.isAuthenticated === false) {
        this.props.history.push("/signin")
      }
    }
    render() {
      return <ComponentToBeRendered ref={this.props.myForwardedRef} {...this.props} />
    }
  }

  function mapStateToProps(state){
    return {
      isAuthenticated: state.currentUser.isAuthenticated,
      user: state.currentUser.user
    }
  }

  const ConnectedComponent = connect(mapStateToProps, null, null, { withRef: true })(Authenticate);
  return React.forwardRef((props, ref) => <ConnectedComponent {...props} myForwardedRef={ref} />);
}



// WEBPACK FOOTER //
// ./src/hocs/withAuth.js